import { createContext } from 'react'

export type CssModuleContextType = Record<string, string>

export const CssModuleContext = createContext<CssModuleContextType>({})
